import React from 'react';

import logo180 from '../../assets/logo180.png';
import logo170 from '../../assets/logo170.png';

const CELEBRATION_ASSETS = {
  score180: {
    image: logo180,
    alt: '180',
    className: 'is-180',
  },
  checkout170: {
    image: logo170,
    alt: '170 checkout',
    className: 'is-170',
  },
};

export default function ScoreCelebrationBanner({ type }) {
  if (!type) return null;

  const celebrationConfig = CELEBRATION_ASSETS[type];

  if (!celebrationConfig) return null;

  return (
    <div className={`x01-score-celebration-banner ${celebrationConfig.className}`.trim()}>
      <img
        src={celebrationConfig.image}
        alt={celebrationConfig.alt}
        className="x01-score-celebration-img"
      />
    </div>
  );
}